/**
 * Shared internals for the storage modules.
 * Encoding helpers and the common StoredApiKey envelope used by every
 * API-key store (admin / OpenAI / Anthropic).
 */

export const STORAGE_VERSION = '1.0';

export interface StoredApiKey {
  value: string;
  createdAt: number;
  version: string;
}

export const sanitizeApiKey = (value: string): string => value.trim().replace(/\s+/g, '');

/**
 * Simple encryption (additional security measures recommended for production)
 */
export const encode = (text: string): string => {
  return btoa(encodeURIComponent(text));
};

export const decode = (encoded: string): string => {
  try {
    return decodeURIComponent(atob(encoded));
  } catch {
    return '';
  }
};
